import * as React from "react";
import {DynamicDialog, DynamicDialogProps, DynamicDialogState} from "shared/controls/Dialogs/core/DynamicDialog";
import {DialogProps} from "shared/controls/Dialogs/core/Dialog";
import {Children, ReactElement, ReactNode} from "react";
import {RNTagItem} from "./RNTagItem";
import {RNTagGroup, RNTagGroupProps} from "./RNTagGroup";
import {Item} from "shared/controls/Tabs/Item";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSearch} from "@fortawesome/free-solid-svg-icons/faSearch";
import {create} from "ladda";
import {RNTags} from "./RNTags";
import {AccordionItem} from "shared/controls/Accordion/AccordionItem";
import {RNTagGroupModel} from "shared/controls/RNTags/RNTagGroup.Model";
import {RNTagItemModel} from "shared/controls/RNTags/RNTagItem.Model";

export class RNTagDialog extends DynamicDialog<RNTagDialogProps, RNTagDialogState> {
    static defaultProps: Partial<RNTagDialogProps> = {
        SkipTags:[]
    };
    public Original:ReactElement<RNTagGroupProps>[];
    public FilterCriteria:string;
    constructor(props: RNTagDialogProps) {
        super(props);
        let childrens:RNTagItem[]=Children.toArray(this.props.children) as any;
        let selectedItem='';
        if(childrens.length>0)
        {
            selectedItem=childrens[0].props.Label;
        }

        this.FilterCriteria='';

        this.state = {
            IsOpen: true,
            SelectedItem:selectedItem,
            IsBusy:false
        };
    }

    GetAdditionalProperties(): DialogProps {
        return {
            Title:'Select an item'
        };
    }

    SubRenderer(): ReactNode {


        return (
            <div>
                <div style={{position:'relative'}}>

                    <FontAwesomeIcon icon={faSearch} style={{position:"absolute",left:3,top:'50%',fontSize:16,marginTop:-8,color:'#dfdfdf'}}/>
                    <input className={'rncontrol'} type={'text'} placeholder={'Search Criteria'} style={{paddingLeft:23,width:'100%'}} value={this.FilterCriteria} onChange={e=>this.Change(e.target.value)}/>
                </div>
                <div >
                    <ul>
                        {this.props.Data.map(group=>{
                            return(
                                group.Children.some(x=>x.Visible)&&
                                <AccordionItem Title={group.Title} IsOpen={true} key={group.Title}>
                                    <div style={{margin:-10}}>
                                        {
                                            group.Children.map(item=>
                                                item.Visible&&<li className={'rnTagItem'} style={{cursor:"pointer",padding:15,border:'1px solid #dfdfdf',margin:0,marginBottom:-1}} onClick={()=>this.SendResult(item)}>{item.Label}</li>

                                            )
                                        }
                                    </div>
                                </AccordionItem>

                            );
                        })}
                    </ul>
                </div>
            </div>
        )
    }


    private Change(value: string) {
        this.FilterCriteria=value;
        this.props.Data.forEach(group=>group.Children.forEach(item=>{
            item.Visible=item.Label.toLowerCase().indexOf(value)>=0;
            }));
        this.forceUpdate();
    }

}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface RNTagDialogProps extends DynamicDialogProps {
    ItemSelected:(item:string)=>void;
    SkipTags:string[];
    Data:RNTagGroupModel[];
}

interface RNTagDialogState extends DynamicDialogState {
    SelectedItem:string;
}

//#endregion "My Region"